import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Select } from '@mui/material';

export default function CustomSelectBox(props) {

    const optionValues = (props.options || []).map((o) => (o && o.value !== undefined ? o.value : o));
    const safeValue = props.value !== undefined && props.value !== null && (props.value === '' || optionValues.includes(props.value))
        ? props.value
        : '';

    return (

        <FormControl
            size="small"
            sx={{
                width: props.width,
                '& .MuiOutlinedInput-root': {
                    width: '100%',
                    minWidth: 0,
                    height: { xl: 28, lg: 24, md: 22 },
                    '& .MuiOutlinedInput-notchedOutline': {
                        border: '1px solid #919191',
                    },
                    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                        border: '1px solid #919191',
                    },
                },

                '& .MuiSelect-select': {
                    fontSize: { xl: '11px', lg: '10px', md: '8px' },
                    padding: {
                        xl: '4px 6px',
                        lg: '2px 10px',
                        md: '1px 5px',
                    },
                    lineHeight: 1,
                    display: 'flex',
                    alignItems: 'center',
                    // marginLeft: '3px',
                    ...props.selectStyle,

                },
                '& .MuiSelect-icon': {
                    fontSize: {
                        xl: '18px',
                        lg: '14px',
                        md: '12px',
                    },
                    right: {
                        xl: 6,
                        lg: 4,
                        md: 2,
                    },
                },
            }}
        >
            <Select
                fullWidth
                value={safeValue}
                displayEmpty
                onChange={(e) => {
                    props.handleChange(e.target.value)
                }}
                disabled={!props.edit}
                inputProps={{ sx: { padding: 0 } }}
                MenuProps={{
                    PaperProps: props.menuStyle ? {
                        sx: {
                            paddingLeft: '3px',
                            paddingRight: '3px',
                            borderRadius: '10px',
                            backgroundColor: '#f3f9fb'
                        },
                    } : {},
                }}
            >
                {!props.menuStyle && <MenuItem value="" disabled>{props.placeholder}</MenuItem>}
                {props.options.map((option, index) => (
                    <MenuItem key={option.value || option} value={option.value || option} style={props.menuStyle ? { borderRadius: '10px', height: '37px', backgroundColor: option.value == "HIGH" ? 'rgba(253, 224, 224, 1)' : option.value == "MEDIUM" ? 'rgba(253, 244, 224, 1)' : 'rgba(224, 239, 253, 1)', marginTop: index > 0 ? 1 : 0 } : {}}
                        sx={{
                            '&:hover': {
                                backgroundColor: '#D3D3D3',
                                color: 'black',
                            },
                            '&.Mui-selected': {
                                backgroundColor: 'grey',
                                color: props.menuStyle ? 'black' : '#fff',
                            },
                            '&.Mui-selected:hover': {
                                backgroundColor: 'grey',
                            },

                            '&.Mui-focusVisible': {
                                backgroundColor: 'grey',
                            },

                            '&.Mui-selected.Mui-focusVisible': {
                                backgroundColor: 'grey',
                            },
                        }}
                    >
                        {option.label || option}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}